import { render, staticRenderFns } from "./quickQuoteReport.vue?vue&type=template&id=2467b464&scoped=true&"
import script from "./quickQuoteReport.vue?vue&type=script&lang=js&"
export * from "./quickQuoteReport.vue?vue&type=script&lang=js&"
import style0 from "./quickQuoteReport.vue?vue&type=style&index=0&id=2467b464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467b464",
  null
  
)

export default component.exports